import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import { handleInputChange } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: The following globals are loaded from external scripts and not imported:
// - $ (jQuery): Used for AJAX requests

class InquiryDeclineModal extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      saving: false,
      declineReason: "",
      validationError: null,
    }
    this.validator = validatorFactory()
    this.handleInputChange = handleInputChange.bind(this)
    this.saveInquiry = this.saveInquiry.bind(this)
  }

  saveInquiry() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({
        saving: true,
        validationError: null,
      })
      const params = {
        decline_reason: this.state.declineReason,
        status: "declined",
      }
      $.post(this.props.endpoint, params, (data) => {
        window.location.reload(false)
      }).fail((data) => {
        const error = "Error: " + data.statusText
        this.setState({
          saving: false,
          validationError: error,
        })
      })
    } else {
      this.forceUpdate()
    }
  }

  render() {
    return (
      <div>
        {this.props.showModal && (
          <Modal
            isOpen={this.props.showModal}
            onClose={this.props.closeModal}
            size="small"
          >
            <Modal.Header title="Decline Lead" />
            <Modal.Body>
              <FormGroup
                inputType="textarea"
                label="Decline Reason:"
                name="declineReason"
                value={this.state.declineReason}
                onChange={this.handleInputChange}
                validation={this.validator.message(
                  "decline_reason",
                  this.state.declineReason,
                  "required"
                )}
              />
              {this.validator.messageWhenPresent(this.state.validationError)}
            </Modal.Body>
            <Modal.Footer
              cancelBtnText="Cancel"
              confirmBtnText="Decline"
              confirmBtnVariant="danger"
              onClose={this.props.closeModal}
              onSubmit={this.saveInquiry}
              confirmBtnLoading={this.state.saving}
            />
          </Modal>
        )}
      </div>
    )
  }
}

InquiryDeclineModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  endpoint: PropTypes.string.isRequired,
}

export default InquiryDeclineModal
